import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShoppingBag4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"shopping-bag-4"} maskId="square-filled-radius-0-stroke-1-IconShoppingBag4"><path fillRule="evenodd" clipRule="evenodd" d="M12 3C9.79086 3 8 4.79086 8 7H16C16 4.79086 14.2091 3 12 3ZM17 7H21V17.5C21 19.433 19.433 21 17.5 21H6.5C4.567 21 3 19.433 3 17.5V7H7C7 4.23858 9.23858 2 12 2C14.7614 2 17 4.23858 17 7Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconShoppingBag4;
